import { ListItem, ListProps } from '@chakra-ui/react'

export type { ListProps }

export default ListItem
